import marketWinnerV2 from '@/components/market/v2/market-winner-v2/market-winner-v2.vue';
import Contract from '@/models/contract';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import { isMarketSingle, isMarketClosed } from '@/utils/helpers';

export const MARKET_CONTRACT_INFO_VALUES_LAYOUT = {
  BLANK: 'blank',
  BLANK_DETAILED: 'blank-detailed',
  CONTRACTS_SUMMARY: 'contracts-summary',
};

export default {
  props: {
    market: {
      type: Object,
      required: false,
      default: null,
    },
    contract: {
      type: Object,
      required: false,
      default: null,
    },
    image: {
      type: String,
      required: false,
      default: null,
    },
    link: {
      required: false,
      default: null,
    },
    layout: {
      type: String,
      default: MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK,
    },
    addFakeContracts: {
      type: Boolean,
      default: true,
    },
    marketId: {},
    contractId: {},
  },
  components: {
    marketWinnerV2,
    marketChangePrice,
  },
  data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT,
    };
  },
  computed: {
    isCompactLayout() {
      const layouts = [
        MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK,
        MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY,
      ];
      return layouts.includes(this.layout);
    },
    isDetailedLayout() {
      const layouts = [
        MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED,
      ];
      return layouts.includes(this.layout);
    },
    marketContracts() {
      if (!this.market || !this.market.contracts) return [];
      const results = Array.from(this.market.contracts || []);
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      const names = ['Yes', 'No'];
      if (this.addFakeContracts && results.length === 1 && names.includes(this.getContractName(results[0]))) {
        const noContract = Object.assign({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results;
    },
    imageUrl() {
      if (this.image !== null) {
        return this.image;
      }
      if (this.contract !== null) {
        return this.contract.contractImageUrl;
      }

      if (this.market !== null) {
        return this.market.marketImageUrl;
      }
      return null;
    },
    imageStyleModifiers() {
      if (this.imageUrl !== null) {
        return {
          'background-image': `url('${this.imageUrl}')`,
        };
      }
      return {};
    },
    title() {
      if (this.contract !== null) {
        return this.contract;
      }

      if (this.market !== null) {
        return this.market.marketName;
      }

      return '';
    },
    isMarketSingle() {
      return this.market !== null && isMarketSingle(this.market);
    },
    detailsLink() {
      if (this.link) return this.link;
      if (this.market !== null) {
        return {
          name: 'market-details',
          params: { marketId: this.market.marketId },
        }
      }
      if (this.marketId !== null) {
        const query = {}
        if (this.contractId !== null) {
          query.contractId = this.contractId;
        }
        return {
          name: 'market-details',
          params: { marketId: this.marketId },
          query
        }
      }
      return '';
    }
  },
  methods: {
    getContactInstance(data) {
      return new Contract(data);
    },
    getContractName(data) {
      return data.contractShortName || data.contractName || data.name;
    },
    contractTitle(data) {
      if (!this.isMarketSingle) {
        return this.getContractName(data);
      }
      return data.noContract ? 'No' : 'Yes';
    },
    contractPrice(data) {
      const instance = this.getContactInstance(data);
      const lastPrice = instance.lastTradePriceAsCents;
      if (!instance.hasLastTradePrice) {
        return 0;
      }
      if (data.noContract) {
        return 100 - lastPrice;
      }
      return lastPrice;
    },
    contractHasLastTradePrice(data) {
      const instance = this.getContactInstance(data);
      return instance.hasLastTradePrice;
    },
    contractChanePrice(data) {
      const instance = this.getContactInstance(data);
      if (!instance.hasLastTradePrice) {
        return 0;
      }
      const price = instance.changePriceAsCents;
      return data.noContract ? -price : price;
    },
    contractLastClosePrice(data) {
      const instance = this.getContactInstance(data);
      return instance.lastClosePrice;
    },
    contractKey(contract) {
      const suffix = contract.noContract ? 'no' : 'yes';
      return `${contract.contractId}-${suffix}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-contract-info-v2/market-contract-info-v2.js